import clsx from "clsx";
import { CardModalProps } from "../CardModal/CardModal";
import { createModal } from "@commonlibs";
import { CameraQRReaderProps } from "../../input/CameraQRReader/CameraQRReader.types";
import CardNavigationModal from "../CardNavigationModal/CardNavigationModal";
import ScanQrWithButton from "ui/transactions/components/input/ScanQrWithButton/ScanQrWithButton";
import { useTranslate } from "ui/locale";

export interface QrScannerModalProps extends CardModalProps {
    onScan: CameraQRReaderProps["onScan"];
}

const QrScannerModal = createModal<QrScannerModalProps>(({ className, onScan, close, ...rest }) => {
    const translate = useTranslate();

    function handleOnScan(address: string) {
        onScan?.(address);
        close();
    }

    return (
        <CardNavigationModal
            header={{ left: "close", onLeftClick: close, title: translate("scan").toUpperCase() }}
            divider
            css={{ height: "100%" }}
            className={clsx("qr-scanner-modal", className)}
            {...rest}
        >
            <ScanQrWithButton css={{ height: "100%" }} onScan={handleOnScan} onClick={close} buttonLabel={translate("close")} {...rest} />
        </CardNavigationModal>
    );
});

export default QrScannerModal;
